/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  CreateRoutineMutationRequest,
  CreateRoutineMutationResponse,
  CreateRoutine400,
  CreateRoutine401,
  CreateRoutine403,
} from '../types/CreateRoutine.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getCreateRoutineUrl() {
  const res = { method: 'POST', url: `/routines` as const };
  return res;
}

/**
 * @summary Create routine
 * {@link /routines}
 */
export async function createRoutine(
  data: CreateRoutineMutationRequest,
  config: Partial<RequestConfig<CreateRoutineMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    CreateRoutineMutationResponse,
    ResponseErrorConfig<CreateRoutine400 | CreateRoutine401 | CreateRoutine403>,
    CreateRoutineMutationRequest
  >({ method: 'POST', url: getCreateRoutineUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
